module.exports = __webpack_public_path__ + "static/img/icon_a.03180534.png";